import { CakeSlice, CookingPot, PartyPopper } from "lucide-react";

export const highlights = [
  {
    title: "Pastelaria e café",
    description: "Uma pausa saborosa, preparada com cuidado e servida com simpatia.",
    icon: CakeSlice,
  },
  {
    title: "Refeições especiais",
    description: "Pratos reconfortantes com disponibilidade confirmada diretamente connosco.",
    icon: CookingPot,
  },
  {
    title: "Encomendas para festas",
    description: "Salgados e opções personalizadas para celebrar sem complicações.",
    icon: PartyPopper,
  },
] as const;
